<template>
  <div class="parent-contact-teacher">
    <div class="page-header">
      <h1>联系老师</h1>
      <p>孩子ID: {{ $route.params.childId }}</p>
      <p>家长联系老师页面，开发中...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParentContactTeacher'
}
</script>

<style lang="less" scoped>
.parent-contact-teacher {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  
  h1 {
    margin: 0 0 16px 0;
    color: #2c3e50;
  }
  
  p {
    color: #7f8c8d;
    margin: 8px 0;
  }
}
</style>
